export default __webpack_public_path__ + "821c8ddedc216fb8adc529c1fea2188d.svg";